import { useTranslation } from 'react-i18next';
import { cn } from '../../../../utils/cn';

/** Glifo de batería con relleno proporcional. Rojo si desconectada o crítica. */
export function BatteryGauge({ pct, conectada = true, className }) {
  const { t } = useTranslation();
  const fill =
    !conectada || pct < 15 ? 'bg-status-error' : pct < 40 ? 'bg-status-warning' : 'bg-status-success';
  return (
    <span
      className={cn('inline-flex items-center gap-1.5', className)}
      title={conectada ? `${t('Batería')} ${pct}%` : t('Batería desconectada')}
    >
      <span className="relative inline-flex items-center">
        <span className="relative w-6 h-3 rounded-[3px] border border-fg-subtle/60 p-[1.5px]">
          <span
            className={cn('block h-full rounded-[1px] transition-all', conectada ? fill : 'bg-status-error')}
            style={{ width: `${conectada ? Math.max(6, pct) : 100}%` }}
          />
        </span>
        <span className="w-[2px] h-1.5 rounded-r-sm bg-fg-subtle/60" />
      </span>
      <span className="tabular-nums text-xs text-fg-muted">{conectada ? `${pct}%` : '—'}</span>
    </span>
  );
}
